module.exports = __webpack_public_path__ + "img/w3_location_white.e4af430a.png";